export const FeatureGates = {
  INTEGRATED_MESSAGING: 'integrated-messaging',
  ZIPRECRUITER: 'ziprecruiter-sponsorship',
  WHATSAPP_SIGN_IN_WITH_FACEBOOK: 'whatsapp-sign-in-with-facebook',
};
